 var unixNow = Math.floor(Date.now() / 1000);

function waitForTimeout(seconds) {
  return new Promise((resolve, reject) => {
     setTimeout(() => { 
        // console.log("Await completed");
        resolve();
     }, seconds * 1000);        
  });
}

 export default unixNow;